<template>
  <div>
    <h3>Faire un don</h3>
    Votre don sera déposé dans le fonds Paraplumes du Club des ornithologues de Québec pour la protection des oiseaux.
    <div style="text-align: center">
      <br/>
      <button class="btn btn-primary " @click="$router.push({ name: 'FaireDonPage' });">
        Faire un don au fonds Paraplumes
      </button>
      <br/>
      <br/>
      <br/>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'MembreDon'
  };
</script>

<style scoped>

</style>
